import React from 'react';

import { StaticImage } from 'gatsby-plugin-image';

import * as styles from './index.module.scss';
import { Row, Col } from 'antd';

const Index = () => {
  return (
    <div className={styles.benefits}>
      <div className={styles.title}>Benefits of using MTT Network</div>
      <video className={styles.golbal} autoPlay loop muted>
        <source src="https://static-s3.mtt.xyz/app/sports/media/Comp%201.mp4" />
      </video>
      <Row
        className={styles.content}
        justify={{
          xxl: 'space-between',
          xl: 'space-between',
          lg: 'center',
        }}
      >
        <Col className={styles.item} xl={{ flex: '50%' }} lg={{ flex: '100%' }}>
          <img
            src="https://cdn-web.mtt.xyz/static/Frame%201410077777.png"
            alt=""
          />
          <section>
            <div className={styles.label}>Security of Game Assets </div>
            <div className={styles.desc}>
              Users can securely mint Game Assets on the MTT Network. And
              through cross-chain solutions, we securely transfer Game Assets
              across different blockchains.
            </div>
          </section>
        </Col>
        <Col className={styles.item} xl={{ flex: '50%' }} lg={{ flex: '100%' }}>
          <img
            src="https://cdn-web.mtt.xyz/static/Frame%201410077778.png"
            alt=""
          />
          <section>
            <div className={styles.label}>More compatible smart contracts</div>
            <div className={styles.desc}>
              The MTT Network uses Tendermint smart contract components,
              allowing developers to deploy their contract applications more
              quickly.
            </div>
          </section>
        </Col>
        <Col className={styles.item} xl={{ flex: '50%' }} lg={{ flex: '100%' }}>
          <img
            src="https://cdn-web.mtt.xyz/static/Frame%201410077779.png"
            alt=""
          />
          <section>
            <div className={styles.label}>Decentralized Storage</div>
            <div className={styles.desc}>
              Through the Validator-Node program, the MTT Network will
              decentralize the deployment of multiple nodes, and data will be
              stored in this decentralized system.
            </div>
          </section>
        </Col>
        <Col className={styles.item} xl={{ flex: '50%' }} lg={{ flex: '100%' }}>
          <img
            src="https://cdn-web.mtt.xyz/static/Frame%201410077780.png"
            alt=""
          />
          <section>
            <div className={styles.label}>DAO Governance</div>
            <div className={styles.desc}>
              Upon the full self-operation of the MTT Network, the ongoing
              construction and development of the entire ecosystem will be
              entrusted to the DAO for governance and management.
            </div>
          </section>
        </Col>
      </Row>
    </div>
  );
};

export default Index;
